import React from 'react';
import { FormControl, FormLabel, Grid } from '@material-ui/core';
import { useStyles } from '../../styles';
import { useStateMachine } from 'little-state-machine';
import { useForm, Controller } from 'react-hook-form';
import { Button, RadioGroup, FormControlLabel, Radio, Typography } from '@mui/material';
import api from '../../../../services/api';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IFormStep } from '../pilotGroupAssessment.interface';
import { updateAction } from '../pilotGroupactions';
import { TaskType } from '../../../../enums/enums';

interface IFormStepExtended extends IFormStep {
  userId: string;
  taskId: string;
  groupId: string;
}

export const Section8: React.FC<IFormStepExtended> = ({ step, setStep, userId, taskId, groupId }) => {
  const { state, actions } = useStateMachine({
    updateAction
  });

  const history = useHistory();

  const { handleSubmit, getValues, control } = useForm({
    defaultValues: state.pilotGroupAssessment.formData as any
  });

  const classes = useStyles();

  const handleBack = () => {
    const partialData = getValues();
    actions.updateAction({ pilotGroupAssessment: { formData: partialData } } as any);
    setStep(step - 1);
  };

  const handleComplete = (data): void => {
    const formData = data;
    const payload = {
      userId: userId,
      taskId: taskId,
      groupId: groupId,
      taskName: TaskType.PilotGroupCoachingAssessment,
      formResponse: formData
    };
    const url = '/tasks/response';
    api
      .post(url, payload)
      .then(() => toast.success('Thank you for submitting your Pilot Group Assessment'))
      .catch(() => toast.error('Error submitting Pilot Group Assessment'))
      .finally(() => history.push('/tasks'));

    actions.updateAction({
      pilotGroupAssessment: {
        formData: null
      }
    } as any);
  };

  const onSubmit = (data: any): void => {
    console.log('Pilot Group FormData: ', data);
    actions.updateAction({
      pilotGroupAssessment: {
        formData: {
          ...data
        }
      }
    } as any);

    handleComplete(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid className={classes.formContent} container spacing={5} alignItems="center" justifyContent="center">
        <Grid container item xs={12} direction="column">
          <FormControl>
            <FormLabel className={classes.formLabel}>
              Would you like to continue with the group? (cadence can be adjusted based on feedback).
            </FormLabel>
            <Typography sx={{ mb: 3, fontSize: '1.2rem', color: 'grey' }}>
              It could be every two, three, four or 6 weeks.
            </Typography>
            <Controller
              render={({ field }) => (
                <RadioGroup style={{ marginLeft: 50 }} {...field}>
                  {['Yes', 'No'].map((option, index) => (
                    <FormControlLabel
                      key={index}
                      value={option}
                      control={<Radio style={{ marginRight: 10 }} color="success" />}
                      label={option}
                      style={{ marginBottom: 8, scale: '110%' }}
                    />
                  ))}
                </RadioGroup>
              )}
              name="continue"
              control={control}
            />
          </FormControl>
        </Grid>

        <Grid item className={classes.buttonContainter}>
          <Button className={classes.button} variant="outlined" color="success" onClick={() => handleBack()}>
            BACK
          </Button>
        </Grid>

        <Grid item className={classes.buttonContainter}>
          <Button className={classes.button} variant="contained" color="success" type="submit">
            SUBMIT
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
